import {store} from 'Store/store.index';
import React from 'react'
import { observer, inject } from 'mobx-react'
import {
  PROTECT_CERTIFICATE_PROTECT,
  PROTECT_SECURITY_POLICIES,
  PROTECT_SECURITY_PROPERTIES,
  PROTECT_DIGITAL_IDS,
} from '../ui/constants/protect.constants';
import { /* AGREEMENT_STATUS, */
  FILL_SIGN_BUTTON,
} from '../ui/constants/fill_sign.constants'
import { TAB_NAME_MAP } from '../../SignatureListContainer/constants'
import wrapDialog from '@/routes/wrapperDialog';

import {
  SecurityPolicies,
  CertificateProtectDialog,
  DigitalIDsDialog,
} from '../../dialogs/index';
import EditorContainer from '../EditorContainer';

  type Props = {
    containerCallbacks:any;
    showAdd:any
  };
  type State = {
  };
  
@inject('appStore', 'driveStore', 'privateDriveStore', 'taskStore', 'userStore', 'collaborationStore')
@observer
export default class ProtectTab extends React.Component<Props, State> {

  pdfui: any;
  uiMgr:EditorContainer;
  state: State ={};

    constructor(props) {
        super(props);
        this.uiMgr = props.containerCallbacks
    }

    componentDidMount(): void {
      const actions = {
        [PROTECT_CERTIFICATE_PROTECT]: this.onShowCertificateProtectDlg,
        [PROTECT_DIGITAL_IDS]: ()=>{
          this.uiMgr.setState({ messageDlgCfg:{
            target:DigitalIDsDialog,
            config:{
                visible:true,
                changeVisible:() => this.uiMgr.setState({ messageDlgCfg: {} }),
                showAdd:this.props.showAdd
            }
          }});
        },
        [PROTECT_SECURITY_POLICIES]: ()=>{
          store.accountStore.updateTrialPermission(PROTECT_SECURITY_POLICIES);

          this.uiMgr.setState({ messageDlgCfg:{
            target:SecurityPolicies,
            config:{
                visible:true,
                changeVisible:() => this.uiMgr.setState({ messageDlgCfg: {} })
            }
          }});
        },
        [PROTECT_SECURITY_PROPERTIES]: ()=>{
          store.accountStore.updateTrialPermission(PROTECT_SECURITY_PROPERTIES);
          window.pdfui.openDialog('file-property-popup').then(popup => {
            popup && popup.show(2);
          });
        },
        [FILL_SIGN_BUTTON]: async ()=>{
          const fillSignTab = await window.pdfui.getComponentByName(TAB_NAME_MAP.FillSign);
          fillSignTab.show()
          fillSignTab.active();
          store.viewer.setEditorTabName(TAB_NAME_MAP.FillSign);
        }
      };
      const {setupViewerActionCallback} = this.props.containerCallbacks;
      Object.keys(actions).map(name => {
        setupViewerActionCallback(name, actions[name]);
      })
    }


    onShowCertificateProtectDlg = () => {
      const pdfDoc = window.pdfui.pdfViewer.currentPDFDoc;
      // @ts-ignore
      const { securityUtils, securityEncryptType } = window.UIExtension.PDFViewCtrl.shared;
  
      const handler = (showAlreadySecuredMsg) => {
        const showDlg = () => {
          store.accountStore.updateTrialPermission(PROTECT_CERTIFICATE_PROTECT);

          this.uiMgr.setState({ messageDlgCfg:{
            target:CertificateProtectDialog,
            config:{
                visible:true,
                changeVisible:() => this.uiMgr.setState({ messageDlgCfg: {} })
            }
          }});
        };
        if (showAlreadySecuredMsg) {
          window.pdfui.confirm({
            message: 'password-protect:warning.already-secured',
            level: 'question',
          }).then(() => {
            showDlg();
          }, () => {});
        } else {
          showDlg();
        }
      }
      pdfDoc.getSecurityType().then(securityType => {
        if (securityType === securityEncryptType.Password) {
          if (pdfDoc.hasOwnerPassword && !securityUtils.getHasInputOwnerPwd()) {
            securityUtils.requestOwnerPassword(window.pdfui, () => {
              handler(true);
            });
          } else {
            handler(true);
          }
        } else if (
          securityType === securityEncryptType.Certificate ||
          securityType === securityEncryptType.Unknown ||
          securityType === securityEncryptType.None
        ) {
          handler(false);
        } else {
          handler(true);
        }
      });
    };

    render() 
    {
      return (
      <React.Fragment>
        </React.Fragment>
      )
    }
  
}
